class TableAddRowManagger {
    constructor() {
        this.elements = []
        this._init()
    }
    _init() {
        const els = document.querySelectorAll('[data-table-add-row]')
        els.forEach(el => {
            this.elements.push(new TableAddRow(el))
        })
    }
}

class TableAddRow {
    constructor(el) {
        this.el = el;
        this._init()
    }
    _init() {
        this.elAction = this.el.querySelector('[data-table-add-row-action]')
        this.elBody = this.el.querySelector('tbody')
        this.elTemplate = this.elBody.querySelector('tr:last-child').cloneNode(true)

        this.elAction.addEventListener('click', e => this.actionHandler(), false)
    }

    actionHandler() {
        this.elBody.appendChild(this.elTemplate.cloneNode(true))
    }
}

export default TableAddRowManagger